import React from 'react'
import AddEditUserForm from '../../../Components/AddEditUserForm/AddEditUserForm';
import { useAddUserMutation } from '../../../Store/Apis/manageUserApi';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import Password from 'antd/es/input/Password';

const AddUser = () => {
  const navigate = useNavigate();
  const [addUser, response] = useAddUserMutation();
  const handleSubmit = (formData) => {
    const data = {
      username: formData.name,
      email: formData.email,
      phone: formData.phoneNumber,
      outletId: formData.outlet,
      roleId: formData.roles,
      password: formData.password
    }
    addUser(data).then((res) => {
      if (res?.data?.status === 200) {
        toast.success(res?.data?.message, { duration: 7000 });
        navigate("/manage-users/existing-users")
      } else if(res?.data?.status === 500){
        toast.success(res?.data?.message, { duration: 7000 });
      } else {
        toast.error(res?.data?.message, { duration: 7000 })
      }
    }).catch((err)=>{
      toast.error(err.toString(), { duration: 7000 })
    });
  }
  return (
    <>
      <div class="row align-items-center justify-content-between mb-2">
        <div class="col">
          <h5 class="fw-500 text-white">{"Add New User"}</h5>
        </div>
      </div>
      <AddEditUserForm onSubmit={handleSubmit} />
    </>
  );
}

export default AddUser;